module.exports = __webpack_public_path__ + "static/media/vencimiento_verde.a483bd2c.svg";